<template>
  <div class="container">
    {{ email }}
    <ulabel>
      <uinput type="email" placeholder="your email" v-model="email"></uinput>
    </ulabel>
    <ubtn @click.prevent.native="fpRequest">Reset Password</ubtn>
  </div>
</template>

<script>
export default {
  data() {
    return {
      email: ""
    };
  },
  methods: {
    fpRequest() {
      this.$upskill.fp_request({ email: this.email }).then(() => {
        // console.log(res)
      });
    }
  },
  created() {
    this.Loaded();
  }
};
</script>
